/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { shopContext } from '../../contexts/aniplus';
import axios from 'axios';
import ContentItem from '../../components/guestBook/ContentItem';
//import socketio from 'socket.io-client';
//import $ from 'jquery';
//import socket from 'socket.io-client/lib/socket';

//const socket = socketio.connect('https://socket.aniplustv.com:4100')

class CardContent extends PureComponent {
  state = {};
  componentDidMount = () => {
    this._getData();
  };

  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    //console.log(contentList)

    if (intReturn === 0) {
      this.setState({
        contentList,
      });
    } else {
    }
  };
  _getDataApi = () => {
    const { apiUrl1 } = this.props;
    return axios.post(apiUrl1 + '/cardContent', { params: {} });
  };
  _renderItem = () => {
    const { selectContentSerial, selectContent } = this.props.childProps;
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <ContentItem
          key={index}
          contentSerial={item.contentSerial}
          title={item.title}
          imageLO={item.imageLO}
          imageL={item.imageL}
          selectContentSerial={selectContentSerial}
          selectContent={selectContent}
        />
      );
    });

    return list;
  };

  render() {
    const { type } = this.props.childProps;
    const { contentList } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <header className="header">
          <nav className="nav">
            {/*<button type="button" className="menuCtrl">이전</button>*/}
          </nav>
        </header>
        <div className="container_wall">
          <div className="guestBook ctrl">
            <div className="ctrl_head">
              <h1 style={{ fontFamily: 'GmarketSansBold' }}>방명록</h1>
              <h3 className="dsc" style={{ fontFamily: 'GmarketSansBold' }}>
                원하시는 작품으로 당신의 소중한 발자취를 남겨주세요!
              </h3>
              <ol className="step">
                <li className="active">
                  <span style={{ fontFamily: 'GmarketSansBold' }}>
                    1. 작품선택
                  </span>
                </li>
                <li>
                  <span style={{ fontFamily: 'GmarketSansBold' }}>
                    2. 스틸컷 선택
                  </span>
                </li>
                <li>
                  <span style={{ fontFamily: 'GmarketSansBold' }}>
                    3. 메모지 선택
                  </span>
                </li>
                {type === 'tablet' ? (
                  <li>
                    <span style={{ fontFamily: 'GmarketSansBold' }}>
                      4. 방명록 남기기
                    </span>
                  </li>
                ) : null}
              </ol>
            </div>

            <div className="ctrl_body">
              <div className="list ani">
                <ul style={{ display: 'flex', marginBottom: 80 }}>
                  {contentList ? this._renderItem() : null}
                </ul>
              </div>
              <div className="m_pagination">
                <p>(총 {contentList ? contentList.length : 0}개)</p>
                <button type="button">
                  <img src={imgUrl + '/img/guestBook/arrw_down.png'} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(CardContent));
